import * as api from '../api';
import { Model } from '../common';
import { Offer } from './Offer';

@Model('OfferSet')
export class OfferSet extends api.ApiOfferSet {

    static ROOT_URL = "/membership/offer_sets";
    static API = api.OfferSetsApi;

    offers: Offer[];
}
